import NimbleEmoji, {
  NimbleEmojiProps,
} from "emoji-mart/dist-es/components/emoji/nimble-emoji";
import * as React from "react";
import { setData, setName, fetchBackgroundImage } from "./constants";

export const Emoji = (
  props: Omit<NimbleEmojiProps, "data" | "set" | "backgroundImageFn">
) => {
  return (
    <NimbleEmoji
      {...props}
      data={setData}
      set={setName}
      backgroundImageFn={fetchBackgroundImage}
    />
  );
};
